import {
  Button,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { Call } from "iconsax-react";
import Navbar from "../../components/Navbar";
import { MailOutline } from "@mui/icons-material";
import Footer from "../../components/Footer";

const Contact = () => {
  return (
    <>
      <Navbar scrolled />
      <Box maxWidth={1200} m="auto" my={{ xs: 8, sm: 24 }} width="90%">
        <Grid
          container
          columns={{ xs: 6, md: 12 }}
          alignItems="center"
          mt={16}
          spacing={8}
        >
          <Grid item xs={6}>
            <Stack alignItems="start">
              <Box data-aos="fade-up">
                <Box
                  py={1}
                  px={2}
                  bgcolor="accent.main"
                  borderRadius={100}
                  mb={2}
                  width="fit-content"
                >
                  <Typography variant="body2" color="accent.contrastText">
                    Contact
                  </Typography>
                </Box>
                <Typography variant="h2">Let’s get in touch</Typography>
                <Typography
                  variant="h6"
                  fontWeight={500}
                  mt={2}
                  color="text.secondary"
                >
                  Fill out this form & we’ll get back you asap
                </Typography>
              </Box>
              <Stack>
                <Stack
                  data-aos="fade-up"
                  direction="row"
                  gap={2}
                  alignItems="center"
                  mt={8}
                >
                  <IconButton sx={{ border: "1px solid" }}>
                    <Call size={32} />
                  </IconButton>
                  <Typography
                    variant="h6"
                    fontWeight={400}
                    color="text.secondary"
                    component="a"
                    href="tel:+918308173010"
                    sx={{ textDecoration: "none" }}
                  >
                    +91 83081 73010
                  </Typography>
                </Stack>
                <Stack
                  data-aos="fade-up"
                  data-aos-delay={100}
                  direction="row"
                  gap={2}
                  alignItems="center"
                  mt={2}
                >
                  <IconButton sx={{ border: "1px solid" }}>
                    <MailOutline sx={{ fontSize: 32 }} />
                  </IconButton>
                  <Typography
                    variant="h6"
                    fontWeight={400}
                    color="text.secondary"
                    component="a"
                    href="mailto:inspireluxurygoa@gmail.com"
                    sx={{ textDecoration: "none" }}
                  >
                    inspireluxurygoa@gmail.com
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <form
              name="contact"
              method="POST"
              data-netlify="true"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <input type="hidden" name="form-name" value="contact" />
              <Stack
                spacing={4}
                borderRadius={6}
                maxWidth={{ lg: 400 }}
                bgcolor="#ffffff20"
                p={{ xs: 2, sm: 6 }}
              >
                <Stack direction="row" spacing={2}>
                  <TextField
                    sx={{ width: "100%" }}
                    label="First Name"
                    name="first-name"
                    variant="outlined"
                    required
                  />
                  <TextField
                    sx={{ width: "100%" }}
                    label="Last Name"
                    name="last-name"
                    variant="outlined"
                    required
                  />
                </Stack>
                <TextField
                  label="Email"
                  name="email"
                  type="email"
                  variant="outlined"
                  required
                />
                <TextField
                  label="Message (Optional)"
                  name="message"
                  rows={4}
                  variant="outlined"
                  multiline
                />
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  color="white"
                >
                  Send message
                </Button>
              </Stack>
            </form>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </>
  );
};

export default Contact;
